module.exports = __webpack_public_path__ + "img/Brock Covin.c02d8884.jpg";